<!-- 
Table for displaying spreadsheet validation errors.
-->
<template>
  <div v-if="isSpreadsheetError">
    <p>
      Spreadsheet could not be uploaded. Please correct the issues below and try uploading again:
    </p>
    <div class="spreadsheet-errors">
      <v-data-table 
        :headers="headers" 
        :items="spreadsheetMessages" 
        :total-items="spreadsheetMessages.length" 
        :loading="false" 
        hide-actions
      >
        <template slot="items" slot-scope="props">
          <tr class="noselect">
            <td class="cell">
              {{ props.item.context }}
            </td>
            <td class="cell">
              <span v-for="(message, index) in props.item.messages" :key="index">{{ message }}<br></span>
            </td>
          </tr>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    error: {
      default: null,
      type: Object
    }
  },
  data() {
    return {
      headers: [
        { text: "Row", align: "left", sortable: false, value: "row" },
        { text: "Spreadsheet issue(s)", align: "left", sortable: false, value: "issues" }
      ]
    };
  },
  computed: {
    isSpreadsheetError() {
      const d = this.error.details.response.data;
      const hasTitle = d && d.title ? true : false;
      return hasTitle && d.title.startsWith("Spreadsheet");
    },
    spreadsheetMessages() {
      return this.isSpreadsheetError ? this.error.details.response.data.errors : [];
    }
  }
};
</script>

<style lang="scss">
div.spreadsheet-errors {
  height: 263px;
  max-height: 263px;
  overflow-y: auto;
}
.cell {
  vertical-align: top;
  padding-top: 5px !important;
}
</style>